import { IS_TRADIN } from './constants'

/**
 * Tradin calls payouts "rebates". The backend keeps the `payout*` naming, so the
 * rename lives purely in the presentation layer: labels, headers, titles and the
 * browser URL. Never apply it to API paths, query params, query keys, socket
 * channels or any value sent back to the API.
 *
 * Text that arrives from the backend (widget titles, filter options, action
 * names, notification copy) is NOT rewritten here — that rename belongs on the
 * backend side.
 */
export const PAYOUT_LABEL = IS_TRADIN ? 'Rebate' : 'Payout'
export const PAYOUTS_LABEL = IS_TRADIN ? 'Rebates' : 'Payouts'

/**
 * Brand-specific URL of the payouts screen. `/payouts` stays reachable on every
 * brand, so existing links and bookmarks keep working.
 */
export const PAYOUTS_ROUTE = IS_TRADIN ? '/rebates' : '/payouts'
